import React from 'react';
import classnames from 'classnames';
import { Select, ChangeContext } from 'tea-component';
import useSearch from './_hooks/useSearch';
import { defaultSelectFilter } from '@gp/utils/common';
import { getPlaceholder, getSelectPanelHeight } from '@gp/utils/select';
import { formatOptions } from './utils';
import { renderButton, defaultOptionTextRenderer } from './utils/renderers';
import './index.scss';

const GPSelect: React.FC<IGPSelectProps> = (props) => {
  const {
    className,
    overlayClassName,
    boxClassName,
    showLabel = true,
    label = '',
    placeholder: placeholderProps,
    appearance = 'button',
    matchButtonWidth: matchButtonWidthProps = true,
    listWidth,
    listHeight: listHeightProps,
    searchable = false,
    searchPlaceholder: searchPlaceholderProps = 'Search',
    filter = defaultSelectFilter,
    searchValue: searchValueProps = '',
    onSearchValueChange: onSearchValueChangeProps,
    onSearch: onSearchProps,
    button: buttonProps,
    optionTextRenderer = defaultOptionTextRenderer,
    options: optionsProps = [],
    value,
    onChange,
    ...restProps
  } = props;

  const placeholder = placeholderProps ?? getPlaceholder('select', label);
  const listHeight = getSelectPanelHeight(searchable, listHeightProps);
  const matchButtonWidth = listWidth ? false : matchButtonWidthProps;

  const { searchValue, onSearchValueChange, onSearch } = useSearch({
    searchable,
    searchValue: searchValueProps,
    onSearchValueChange: onSearchValueChangeProps,
    onSearch: onSearchProps,
  });

  const options = formatOptions(optionsProps, {
    searchable,
    searchValue,
    optionTextRenderer,
  });

  const button = renderButton(buttonProps, {
    options,
    value,
    showLabel,
    label,
    placeholder,
    optionTextRenderer,
  });

  const handleChange = (
    payload: string,
    context: ChangeContext<React.SyntheticEvent<Element, Event>>,
  ) => {
    if (value === payload) return;
    onChange?.(payload, context);
  };

  return (
    <Select
      {...restProps}
      className={classnames('dbg-common-select', className)}
      overlayClassName={classnames(
        'dbg-common-select-overlay globalpedia-custom-scrollbar',
        overlayClassName,
      )}
      boxClassName={classnames('globalpedia-modal-font14', boxClassName)}
      placeholder={placeholder}
      appearance={appearance}
      matchButtonWidth={!options?.length ? true : matchButtonWidth}
      listWidth={listWidth}
      listHeight={listHeight}
      searchable={searchable}
      searchPlaceholder={searchPlaceholderProps}
      filter={filter}
      searchValue={searchValue}
      onSearchValueChange={onSearchValueChange}
      onSearch={onSearch}
      button={button}
      options={options}
      value={value}
      onChange={handleChange}
    />
  );
};

export default GPSelect;
